import React from 'react';
import { SimpleGrid } from '@chakra-ui/react';
import ProductCardSkeleton from './ProductCardSkeleton';

const ProductGridSkeleton = () => {
  return (
    <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={8}>
      {Array.from({ length: 6 }).map((_, index) => (
        <ProductCardSkeleton key={index} />
      ))}
    </SimpleGrid>
  );
};

export default ProductGridSkeleton;
